import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Dashboard
export const AllTotalBusiness = createAsyncThunk(
  "common/dashboard/all-totalbusiness",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTotalBusiness);

      return res?.data?.total_business || 0;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "totalbusiness",

  initialState: {
    totalbusiness: 0,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // Pending
      .addCase(AllTotalBusiness.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      // Success
      .addCase(AllTotalBusiness.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.totalbusiness = action.payload;
      })

      // Failed
      .addCase(AllTotalBusiness.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
